import { bootstrap } from './app/bootstrap';

/*
 * Entry point (spec §4.1). bootstrap() owns init order; a failure renders a
 * plain-HTML fatal fallback so the user never sees a blank page.
 */
bootstrap().catch((error: unknown) => {
  console.error('Fatal boot error', error);
  const root = document.getElementById('root');
  if (root) {
    /*
     * Pre-React fatal fallback: this raw HTML is injected when bootstrap()
     * throws, before React or the design-system stylesheet is guaranteed to
     * have loaded, so no token / CSS custom property is reliably in scope. A
     * literal neutral grey is the only safe choice here — the spec §12 token
     * rule is intentionally exempted for this one pre-boot string.
     */
    /* eslint-disable no-restricted-syntax */
    root.innerHTML = `
      <div style="font-family: system-ui; padding: 2rem; max-width: 32rem; margin: 4rem auto;">
        <h1 style="font-size: 1.25rem; margin-bottom: 0.5rem;">Something went wrong</h1>
        <p style="color: #666;">The application failed to start. Please refresh the page or contact support.</p>
      </div>`;
    /* eslint-enable no-restricted-syntax */
  }
});
